/*  ========================================================================
    # Sections - Posts - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import PickedPosts from './PickedPosts';

const containers = document.querySelectorAll('div[data-react-app="PickedPosts"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = containers[i].attributes['data-guid']?.value;
  const props = window.reactProps[containerGuid];

  createRoot(containers[i]).render(<PickedPosts {...props} />);
}
